module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <my-item-family-consult-delete></my-item-family-consult-delete>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/familia/item-family.component.html
// module id = ./src/app/familia/item-family.component.html
// module chunks = main